import {Button, Form, Row, Space, Typography} from "antd";
import {
  ButtonExcel,
  InputFields,
  ListActionButton,
  ModalCustom,
  Notification,
} from "components/common";
import TableCustom from "components/common/TableCustom/TableCustom";
import React, {useEffect, useRef, useState} from "react";
import {columns, fields} from "./config";
import Icons from "assets/icons";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {setActiveKey} from "redux/reducer/common";
import {LOAI_FORM, tabKeys} from "types/enums";
import {
  setIdProposeShopping,
  setDetailShopping,
  getDetailProposeShopping,
} from "redux/reducer/proposeShopping";
import {shoppingService} from "api";
import {DIA_DIEM_MUA_SAM, TRANG_THAI_MUA_SAM} from "types/enums/shopping";
import ReceiptModal from "../ReceiptModal/ReceiptModal";
import {isValuable, toNumber} from "helper/common";
import ModalApprove from "./ModalApprove/ModalApprove";
import ModalDeny from "./ModalDeny/ModalDeny";
const ListProposeShopping = props => {
  const tableRef = useRef(null);
  const [total, setTotal] = useState(0);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState();
  const activeTab = useAppSelector(state => state.common.activeTab);
  const [isLoading, setIsLoading] = useState(false);
  const modalPrintRef = useRef(null);
  const modalApproveRef = useRef(null);
  const modalDenyRef = useRef(null);
  const modalApproveChildRef = useRef(null);
  const modalDenyChildRef = useRef(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const listActionButton = (value, record, index) => {
    return (
      <ListActionButton
        deleteFunction={() => {
          deleteProposeShopping(record?.id);
        }}
        editFunction={() => {
          navigateToDetail(record?.id);
        }}
        printFunction={() => {
          dispatch(getDetailProposeShopping(record?.id));
          modalPrintRef?.current?.openModal();
        }}
      ></ListActionButton>
    );
  };

  const [params, setParams] = useState<any>({});
  const getData = async params => {
    setSelectedRowKeys([]);
    try {
      setIsLoading(true);
      const res = await shoppingService.getListProposeShopping(params);
      setIsLoading(false);
      setData(res?.data?.map(e => ({...e, key: e?.id})));
      setTotal(res?.total);
    } catch (error) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (activeTab == tabKeys.PROPOSE_SHOPPING.LIST) {
      getData(params);
    }
  }, [params, activeTab]);
  const deleteProposeShopping = async id => {
    try {
      await shoppingService.deleteProposeShopping(id);
      Notification("success", "Đã xóa đề nghị");
      onClickSearch();
    } catch (error) {
      Notification("error", "Đã có lỗi");
    }
  };
  const navigateToDetail = id => {
    dispatch(setIdProposeShopping(id));
    dispatch(setActiveKey(tabKeys.PROPOSE_SHOPPING.DETAIL));
  };
  const navigateToNew = () => {
    dispatch(setActiveKey(tabKeys.PROPOSE_SHOPPING.DETAIL));
    dispatch(setIdProposeShopping(null));
    dispatch(setDetailShopping(null));
  };

  const onClickSearch = () => {
    setParams({...form.getFieldsValue(), page: 1});
    setPage(1);
  };
  const onChangePagination = (page, limit) => {
    setParams({...params, page: page, limit: limit});
    setPage(page);
  };
  const setPage = page => {
    tableRef?.current?.setPage(page);
  };
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onClickSearch();
    }
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: (selectedRowKeys: React.Key[]) => {
      setSelectedRowKeys(selectedRowKeys);
    },

    getCheckboxProps: (record: any) => ({
      disabled:
        !isValuable(params?.trangThai) ||
        params?.trangThai == TRANG_THAI_MUA_SAM.NHAP, // Column configuration not to be checked
      name: record.name,
    }),
  };
  useEffect(() => {
    console.log(selectedRowKeys);
  }, [selectedRowKeys]);
  return (
    <div className="">
      <div className="container" onKeyDown={onKeyDown} tabIndex={0}>
        <Form form={form}>
          <Row gutter={[8, 8]}>
            <InputFields data={fields}></InputFields>
          </Row>
          <Row justify={"end"} style={{marginTop: 8}}>
            <Space>
              <Button
                className="btn-sub"
                icon={<Icons.reload />}
                onClick={() => {
                  form.resetFields();
                  onClickSearch();
                }}
              >
                Xoá tìm kiếm
              </Button>
              <Button
                type="primary"
                icon={<Icons.search />}
                onClick={onClickSearch}
              >
                Tìm kiếm
              </Button>
            </Space>
          </Row>
        </Form>
      </div>
      <div className="container">
        <Row justify={"space-between"} style={{marginBottom: 8}}>
          <Typography.Text strong>Danh sách đề nghị</Typography.Text>
          <Space>
            <Button className="btn-sub" onClick={navigateToNew}>
              Tạo đề nghị mua sắm
            </Button>
            {isValuable(params?.trangThai) &&
              params?.trangThai != TRANG_THAI_MUA_SAM.NHAP &&
              params?.trangThai != TRANG_THAI_MUA_SAM.GD_DA_DUYET && (
                <Button
                  className="btn-sub"
                  onClick={() => {
                    modalApproveRef?.current?.openModal();
                  }}
                  disabled={toNumber(selectedRowKeys?.length) == 0}
                >
                  Phê duyệt
                </Button>
              )}
            {isValuable(params?.trangThai) &&
              params?.trangThai != TRANG_THAI_MUA_SAM.GD_DA_DUYET &&
              params?.trangThai != TRANG_THAI_MUA_SAM.NHAP && (
                <Button
                  className="btn-sub"
                  onClick={() => {
                    modalDenyRef?.current?.openModal();
                  }}
                  disabled={toNumber(selectedRowKeys?.length) == 0}
                >
                  Từ chối
                </Button>
              )}
          </Space>
        </Row>
        <TableCustom
          isLoading={isLoading}
          total={total}
          ref={tableRef}
          columns={columns}
          listActionButton={listActionButton}
          onChangePagination={onChangePagination}
          dataSource={data}
          onDoubleClick={(record, rowIndex) => {
            navigateToDetail(record?.id);
          }}
          rowSelection={{
            type: "checkbox",
            ...rowSelection,
          }}
        ></TableCustom>
        <ModalCustom
          title="Phiếu đề nghị mua sắm"
          isLoading={isLoading}
          ref={modalPrintRef}
          width={1000}
        >
          <ReceiptModal></ReceiptModal>
        </ModalCustom>
        <ModalCustom
          title={`${params?.trangThai == 0 ? "Gửi" : "Phê duyệt"} đề nghị`}
          isLoading={isLoading}
          ref={modalApproveRef}
          width={1000}
          onOpenModal={() => {
            modalApproveChildRef?.current?.resetFields();
          }}
        >
          <ModalApprove
            ref={modalApproveChildRef}
            selectedRowKeys={selectedRowKeys}
            getData={() => {
              getData(params);
            }}
            trangThai={params?.trangThai}
          ></ModalApprove>
        </ModalCustom>
        <ModalCustom
          title={`Từ chối đề nghị`}
          isLoading={isLoading}
          ref={modalDenyRef}
          width={1000}
          onOpenModal={() => {
            modalDenyChildRef?.current?.resetFields();
          }}
        >
          <ModalDeny
            ref={modalDenyChildRef}
            selectedRowKeys={selectedRowKeys}
            getData={() => {
              getData(params);
            }}
          ></ModalDeny>
        </ModalCustom>
      </div>
    </div>
  );
};
export default ListProposeShopping;
